import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// const baseURL = 'http://127.0.0.1:8000/api/v1'; //local
const baseURL = 'https://merchantapi.birrionapi.com/api/v1'; //production


let https = axios.create({
    baseURL: baseURL
});

https.interceptors.request.use((config) => {
    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json';
    config.headers['Accept'] = config.headers['Accept'] || 'application/json';
    const merchant = JSON.parse(localStorage.getItem("bMerchant"));
    if(merchant){
        config.headers["x-access-merchant"] = merchant.username;
    }
    return config;
}, (error) => {

});

https.interceptors.response.use((response) => {
    if (response.config.method === "post"){
        toast(response.data.message)
    }
    return response
}, (error) => {
    // console.dir(error);
    toast.error(error?.response?.data?.message || error?.message);
    let status = error.response?.status;
    let data = error.response?.data || {};
    data.status = status;
    throw data;
});

export default https